import React, { useEffect, useState } from "react";
import { TabPanel, TabView } from "primereact/tabview";
import SalesHistory from "../../../components/Reports/Dashboard/Today/SalesHistory";
import CancelHistory from "../../../components/Reports/Dashboard/Today/CancelHistory";
import OnlineHistory from "../../../components/Reports/Dashboard/Today/OnlineHistory";
import MigratedHistory from "../../../components/Reports/Dashboard/Today/MigratedHistory";
import DashboardTodayCount from "../../../components/Reports/Dashboard/Today/DashboardTodayCount";
import OnlineCancellationHistory from "../../../components/Reports/Dashboard/Today/OnlineCancellationHistory";
import { getLocalUserInfo } from "../../../utility/authHelper";
import { userCompanyId } from "../../../utility/helpers";
import { isNumber } from "../../../utility/is";

export default function Index() {
    const { counter_id } = getLocalUserInfo();
    const [activeIndex, setActiveIndex] = useState(0);
    const [remainingHeight, setRemainingHeight] = useState(0);
    const [currentPageReportHeight, setCurrentPageReportHeight] = useState(0);

    const calculateRemainingHeight = (reportHeight = 0) => {
        const viewportHeight = window.innerHeight;
        const usedHeight = document.getElementById("dashboard").offsetHeight;
        setRemainingHeight(
            isNumber(reportHeight) && reportHeight > 0 && reportHeight < 5
                ? 200
                : viewportHeight - usedHeight - 80
        );
    };

    const handleTabChange = (e) => {
        setActiveIndex(e.index);
    };

    useEffect(() => {
        calculateRemainingHeight();
        window.addEventListener("resize", calculateRemainingHeight);
        return () =>
            window.removeEventListener("resize", calculateRemainingHeight);
    }, []);

    useEffect(() => {
        calculateRemainingHeight(currentPageReportHeight);
    }, [currentPageReportHeight]);

    return (
        <div id="dashboard" className="flex flex-col gap-y-3">
            <DashboardTodayCount />
            <div className="flex gap-y-3 overflow-x-auto">
                <div className="flex-grow">
                    <div className="card bg-white">
                        <TabView
                            activeIndex={activeIndex}
                            onTabChange={handleTabChange}
                        >
                            <TabPanel
                                header="Today's Sales History"
                                id="dashboard_todays_sales_history"
                            >
                                <SalesHistory
                                    cb={(paramObj) =>
                                        setCurrentPageReportHeight(
                                            paramObj?.bodyCount || 0
                                        )
                                    }
                                />
                            </TabPanel>
                            <TabPanel
                                header="Today's Cancel History"
                                id="today_cancel_history"
                            >
                                <CancelHistory />
                            </TabPanel>

                            {/* <TabPanel
                            header="Today's Migrated History"
                            id="today_migrated_history"
                        >
                            <MigratedHistory />
                        </TabPanel> */}

                            {!counter_id ? (
                                <TabPanel
                                    header="Today's Online History"
                                    id="today_online_history"
                                >
                                    <OnlineHistory activeIndex={activeIndex} />
                                </TabPanel>
                            ) : null}

                            {!counter_id ? (
                                <TabPanel
                                    header="Today's Online Cancellation History"
                                    id="today_online_cancellation_history"
                                >
                                    <OnlineCancellationHistory />
                                </TabPanel>
                            ) : null}
                        </TabView>
                    </div>
                </div>
            </div>
            {userCompanyId() ? (
                <div
                    style={{
                        height: `${remainingHeight}px`,
                    }}
                    className="flex justify-end items-end text-[12px]"
                >
                    <div className="flex items-center">
                        <span className="mr-2 font-semibold">Powered by</span>
                        <img
                            src="/images/logo.png"
                            className="h-8 me-3"
                            alt="bdtickets Logo"
                        />
                    </div>
                </div>
            ) : null}
        </div>
    );
}
